import {DiscountSchemeRestDto, MultilingualFieldRestDto, ProductFilterRestDto} from "@/api/pharma-cpc-mgmt/models";
import {DiscountSchemeTypeEnum} from "@/api/enums/discount-scheme-type-enum";
import {DiscountTypeEnum} from "@/api/enums/discount-type-enum";
import {CombinationDiscountScopeEnum} from "@/api/enums/combination-discount-scope-enum";
import {StatusEnum} from "@/api/enums/status-enum";
import {ProductFilterRestDtoModel} from "@/models/api/pharma-cpc-mgmt/ProductFilterRestDtoModel";
import {formatDateObjectToDateString} from "@/helpers/functions/date-time";
import {
    MultilingualTextFieldRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/MultilingualTextFieldRestDtoModel";
import {MultilingualTextFieldRestDto} from "@/api/pharma-cpc-product-mgmt/models";

export class DiscountSchemeRestDtoModel implements DiscountSchemeRestDto {
    name: string;
    title?: MultilingualFieldRestDto|null;
    scheme_type_code?: DiscountSchemeTypeEnum|null;
    type_code: DiscountTypeEnum;
    combination_scope_code?: CombinationDiscountScopeEnum|null;
    discount_value?: number|null;
    buy_quantity?: number|null;
    get_quantity?: number|null;
    client_group_code?: string|null;
    max_allowed_discount_amount?: number|null;
    discount_message?: MultilingualFieldRestDto|null;
    exclude_prescription_required: boolean;
    is_standard_price_visible?: boolean|null;
    is_discount_visible?: boolean|null;
    is_scheme_cumulative_with_promo_codes?: boolean|null;
    product_filter?: ProductFilterRestDto|null;
    begin_date: string;
    end_date?: string|null;
    status_code: StatusEnum;
    unapplied_message?: MultilingualFieldRestDto|null;


    constructor(
        name: string,
        scheme_type_code: DiscountSchemeTypeEnum | null,
        type_code: DiscountTypeEnum,
        discount_message: MultilingualFieldRestDto | null,
        exclude_prescription_required: boolean,
        is_standard_price_visible: boolean | null,
        is_discount_visible: boolean | null,
        is_scheme_cumulative_with_promo_codes: boolean | null,
        product_filter: ProductFilterRestDto | null,
        begin_date: string,
        status_code: StatusEnum,
        unapplied_message: MultilingualFieldRestDto | null
    ) {
        this.name = name;
        this.scheme_type_code = scheme_type_code;
        this.type_code = type_code;
        this.discount_value = null;
        this.client_group_code = null;
        this.max_allowed_discount_amount = null;
        this.discount_message = discount_message;
        this.exclude_prescription_required = exclude_prescription_required;
        this.is_standard_price_visible = is_standard_price_visible;
        this.is_discount_visible = is_discount_visible;
        this.is_scheme_cumulative_with_promo_codes = is_scheme_cumulative_with_promo_codes;
        this.product_filter = product_filter;
        this.begin_date = begin_date;
        this.end_date = null;
        this.status_code = status_code;
        this.unapplied_message = unapplied_message;
    }

    static createWithDefaults(): DiscountSchemeRestDtoModel {
        return new DiscountSchemeRestDtoModel(
            '',
            DiscountSchemeTypeEnum.MANUAL_INPUT,
            DiscountTypeEnum.PERCENTAGE,
            MultilingualTextFieldRestDtoModel.createWithDefaults(),
            false,
            true,
            true,
            false,
            ProductFilterRestDtoModel.createWithDefaults(),
            formatDateObjectToDateString(new Date()),
            StatusEnum.NOT_PUBLISHED,
            {
                nl: 'Voeg producten toe om van de aanbieding te genieten.',
                fr: 'Ajouter des produits pour profiter de l\'offre',
                en: 'Add products to benefit from the offer',
                de: 'Produkte hinzufügen, um von dem Angebot zu profitieren',
            } as MultilingualTextFieldRestDto
        );
    }
}
